import { apiUrl2 } from '../../../settings'

export const addTeamTargetUrl = () => {
  return apiUrl2 + '/teamTarget/add'
}

export const getUkMarketingUserUrl = () => {
  return apiUrl2 + '/teamTarget/getUkMarketingUsers'
}
